const LockerCardRoutingAction = ({ locker }) => (
  <a
    href={`https://www.google.com/maps/dir/?api=1&destination=${locker.latitude},${locker.longitude}`}
    target="_blank"
    rel="noopener noreferrer"
    className="text-red-brand underline hover:text-bleu-hover cursor-pointer inline-block"
  >
    Vezi ruta
  </a>
);

export default LockerCardRoutingAction;
